import { formatToBRL } from "@verde/utils";
import React, { type ReactNode } from "react";
import { tv } from "tailwind-variants";

interface CreditDialogCreditItemProps {
  selected?: boolean;
  prefix?: ReactNode;
  title: ReactNode;
  value: number;
}

const styles = tv({
  slots: {
    base: "flex items-center justify-between gap-2 rounded border border-neutral-light-3 bg-neutral-light-pure px-4 py-3",
    description: "flex items-center gap-2",
    value: "rounded px-3 py-2 bg-neutral-light-1",
  },
  variants: {
    selected: {
      true: {
        base: "border-neutral-light-2 bg-neutral-light-1",
        value: "border border-brand-yellow bg-off-yellow",
      },
    },
  },
});

function CreditDialogCreditItem({
  selected,
  prefix,
  title,
  value,
}: CreditDialogCreditItemProps) {
  return (
    <div
      className={styles().base({
        selected,
      })}
    >
      <div className={styles().description()}>
        <div className="flex items-center gap-2 text-neutral-dark-pure">
          {typeof prefix === "string" ? (
            <span className="text-neutral-dark-1">{prefix}</span>
          ) : (
            prefix
          )}
          {typeof title === "string" ? <span>{title}</span> : title}
        </div>
      </div>

      <div
        className={styles().value({
          selected,
        })}
      >
        <p className="font-semibold text-neutral-dark-pure">
          {selected ? "Total à pagar: " : null}{" "}
          {formatToBRL(value, {
            includeDecimals: true,
          })}
        </p>
      </div>
    </div>
  );
}

export default React.memo(CreditDialogCreditItem);
